'use strict';

angular.module('far.index')
    .controller('IndexViewController', function($http, $log, formsUtils) {
        $http.get(Routing.generate('api_event_get_event_project_homepage'))
            .then(function(response) {
                for(var key in response.data) {
                    var item = response.data[key];

                    item.url = Routing.generate('event_view', {id: item.id});

                    vm.projects.push(item)
                }
            })
            .catch(function(response) {
                $log.error(response);
            });

        $http.get(Routing.generate('api_get_rubric_list'))
            .then(function(response) {
                for(var key in response.data) {
                    var item = response.data[key];

                    item.url = Routing.generate('blog_rubric', {slug: item.slug});
                    if(item.posts_count > 0) {
                         item.posts_count = item.posts_count + ' ' + formsUtils.numEnding( item.posts_count, ['статья', 'статьи', 'статей'] );
                    } else {
                         item.posts_count = 0;
                    }
                    switch (item.slug) {
                        case 'putievoditiel-po-ghornym-raionam':
                            item.url = Routing.generate('mountains_routes_by_peak');
                            item.url_text = 'Перейти';
                            break;
                        case 'strakhovaniie-ekstriemal-nykh-vidov-sporta':
                            item.url = Routing.generate('insurance_index');
                            item.url_text = 'Перейти';
                            break;
                        case 'al-pinistskiie-kluby-v-rossii':
                            item.url = Routing.generate('search_alpclub');
                            item.url_text = 'Перейти';
                            break;
                        case 'al-pinistskiie-laghieria':
                            item.url = Routing.generate('search_camp');
                            item.url_text = 'Перейти';
                            break;
                        default:
                            item.url_text = 'Читать статьи';
                            break;
                    }

                    vm.rubrics.push(item)
                }
            })
            .catch(function(response) {
                $log.error(response);
            });

        $http.get(Routing.generate('api_get_homepage_post_list'))
            .then(function(response) {
                for(var key in response.data) {
                    var item = response.data[key];
                    item.url = Routing.generate('blog_post', {rubric: item.rubric.slug, post: item.slug});

                    vm.posts.push(item)
                }
            })
            .catch(function(response) {
                $log.error(response);
            });

        var vm = {
            projects: [],
            disciplines: [],
            rubrics: [],
	    posts: [],
            twoColumn: function (array, type) {
                var index = 0,
                    result = [];

                for(var key in array) {
                    var item = array[key],
                        i = key % 2;

                    switch (type) {
                        case 'project' :
                            item.url = Routing.generate('event_view', {id: item.id});
                            break;
                        case 'blog' :
                            item.url = Routing.generate('blog_post', {rubric: item.rubric.slug, post: item.slug});
                            item.posts_count = item.posts_count + ' ' + formsUtils.numEnding( item.posts_count, ['статья', 'статьи', 'статей'] );
                            break;
                    }


                    if (angular.isUndefined(result[index])) {
                        result[index] = [];
                    }

                    result[index][i] = item;

                    if (i) {
                        index++;
                    }
                }

                return result;
            }
        };

        return vm;
    });
